<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <label style="color:darkred">
            Módulo para crear comisiones***
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group align="left">
            <label for="fci">Fecha de inicio</label>
            <b-input-group size="sm" class="mb-2" id="fci" lab>
              <b-form-datepicker
                  name="nombre"
                  placeholder="Fecha de Inicio"
                  v-model="$v.filtro.fechaInicio.$model"
                  :state="validateState('fechaInicio')"
                  :max="new Date()"
              ></b-form-datepicker>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group align="left">
            <label for="fcf">Fecha de fin</label>
            <b-input-group size="sm" class="mb-2" id="fcf" lab>
              <b-form-datepicker
                  name="nombre"
                  placeholder="Fecha de Fin"
                  :min="filtro.fechaInicio"
                  :max="new Date()"
                  v-model="$v.filtro.fechaFin.$model"
                  :state="validateState('fechaFin')"
              ></b-form-datepicker>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
        <b-col></b-col>
        <b-col class="text-right">
          <b-button
              variant="outline-primary"
              :disabled="loader"
              @click="crearComisiones()"
          >
            <span v-if="!loader">Generar</span>
            <span v-else>
                  <b-spinner small></b-spinner>
                  Generando...
                </span>
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
  name: "CrearComisiones",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false,
      filtro: {
        fechaInicio: null,
        fechaFin: null,
      },
    }
  },
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods:{
    crearComisiones() {
      this.$v.filtro.$touch();
      if (!this.$v.filtro.$invalid) {
        this.loader = true;
        this.datosTabla = [];

        const envio = {
          fechaInicio: this.$moment(this.filtro.fechaInicio)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          fechaFin: this.$moment(this.filtro.fechaFin)
              .add(1, "days")
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          horas: this.$horas(),
        };

        this.$http
            .post(this.$api + "comisiones/crear/comisiones/sesion", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: 'success',
                  title: 'Éxito',
                  text: 'Comisiones generadas correctamente'
                });
              }
            })
            .finally(() => {
              this.loader = false;
            });
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>

</style>